import {SERVICES} from '@/const';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;

export const IMAGES = {
  SHARE: '86d548bdf3004995774ef154b7a19abcf49bc59a8e2f93bfe6e2a88149233032.png',
  BANNER: 'ee62ec07838515d666a33761610828373734e41c817964a2046ad8cbf4b42576.png',
  BANNER_H5: '48f1338770316fe322b9de313592ba53e075d7b5e00fcff8e9faebbec040858d.png',
  STEP1: '7f666ca8a249cb9a13a6bda051fd2121069b226a1f27a619ef76b0b99ee51fe7.png',
  STEP2: '1589d0ca7cf7de07c5ecc5f2b72d2aeef06bf8bb907bd21357b677e27c2bce94.png',
  STEP3: '1525b699f20bdcd8cc894b249710a2e53f2063b31f8def5bd9dcd929e586903e.png',
  ARROW: 'c289c298c9c433b68b5d5ea50ae6dd21ef24b933e2ea9b88afa1daf9ad288859.png',
  ARROW_DOWN: 'ea4e5a3f4a7bd472b2610bb90fad7eb37e0e4c82aa72fd47bab30cfcdb7bd795.png',
  INFO: '5131bcbbfa46fa3182117003d649726851a53d01cb78b9e50582bc767cdc4979.png',
};
Object.keys(IMAGES).forEach((key) => (IMAGES[key] = [PREFIX_RECEIVE, IMAGES[key]].join('')));
